



















































































































import Vue from "vue";
import {
  VueTableRequest,
  ServiceProductApi,
  ServiceProductOrderApi,
  AddServiceProductOrderRequest
} from "@/api";
import stateMixin from "@/mixins/state";
import { formatCurrency } from "@/util/currency";

export default Vue.extend({
  data() {
    return {
      data: [],
      headers: [
        { text: "Aantal", value: "amount", width: 80, sortable: false },
        {
          text: "Artikelcode",
          align: "left",
          sortable: false,
          value: "articleCode",
          width: 100
        },
        { text: "Afbeelding", value: "image", width: 100 },
        { text: "Naam", value: "name" },
        {
          text: "Prijs (excl. BTW)",
          value: "price",
          width: "150",
          align: "right"
        },
        { text: "Totaal", value: "total", width: "100", align: "right" }
      ],
      options: {
        page: 1,
        itemsPerPage: 20
      }
    };
  },
  name: "ServiceProductOrderAdd",
  mixins: [stateMixin],
  computed: {
    orderRows: function(): AddPharmacistRequest {
      return this.data
        .filter(item => {
          return item.amount && item.amount >= 1;
        })
        .map(item => {
          return {
            amount: item.amount,
            serviceProductId: item.serviceProductId
          };
        });
    },
    totalProductCount: function(): number {
      let count = 0;
      this.orderRows.forEach(item => (count += Number(item.amount)));
      return count;
    }
  },
  methods: {
    formatCurrency,
    fetch: async function() {
      this.setState(this.states.LOADING);
      const api = new ServiceProductApi();
      try {
        const request: VueTableRequest = {
          sortBy: undefined,
          descending: undefined,
          page: this.options.page,
          rowsPerPage: this.options.itemsPerPage,
          search: ""
        };
        const { data } = await api.serviceProductGetServiceProducts(request);
        this.data = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    async createServiceProductOrder() {
      this.setState(this.states.LOADING);
      const api = new ServiceProductOrderApi();
      try {
        const { data } = await api.serviceProductOrderAddServiceProductOrder({
          orderRows: [...this.orderRows]
        });
        this.setState(this.states.COMPLETED);
        this.reset();
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    reset() {
      this.data.forEach(item => (item.amount = 0));
    }
  },
  watch: {
    options: {
      handler() {
        this.fetch();
      },
      deep: true,
      immediate: false
    }
  }
});
